var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vux-confirm" },
    [
      _c(
        "x-dialog",
        {
          attrs: {
            "dialog-class":
              _vm.theme === "android"
                ? "weui-dialog weui-skin_android"
                : "weui-dialog",
            "mask-transition": _vm.maskTransition,
            "dialog-transition":
              _vm.theme === "android" ? "vux-fade" : _vm.dialogTransition,
            "hide-on-blur": _vm.hideOnBlur,
            "mask-z-index": _vm.maskZIndex
          },
          on: {
            "on-hide": function($event) {
              return _vm.$emit("on-hide")
            }
          },
          model: {
            value: _vm.showValue,
            callback: function($$v) {
              _vm.showValue = $$v
            },
            expression: "showValue"
          }
        },
        [
          !!_vm.title
            ? _c(
                "div",
                {
                  staticClass: "weui-dialog__hd",
                  class: { "with-no-content": !_vm.showContent }
                },
                [
                  _c("strong", { staticClass: "weui-dialog__title" }, [
                    _vm._v(_vm._s(_vm.title))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showContent
            ? [
                !_vm.showInput
                  ? _c(
                      "div",
                      { staticClass: "weui-dialog__bd" },
                      [
                        _vm._t("default", function() {
                          return [
                            _c("div", {
                              domProps: { innerHTML: _vm._s(_vm.content) }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  : _c("div", { staticClass: "vux-prompt" }, [
                      _vm.getInputAttrs().type === "checkbox"
                        ? _c(
                            "input",
                            _vm._b(
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.msg,
                                    expression: "msg"
                                  }
                                ],
                                ref: "input",
                                staticClass: "vux-prompt-msgbox",
                                attrs: {
                                  placeholder: _vm.placeholder,
                                  type: "checkbox"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.msg)
                                    ? _vm._i(_vm.msg, null) > -1
                                    : _vm.msg
                                },
                                on: {
                                  touchend: _vm.setInputFocus,
                                  change: function($event) {
                                    var $$a = _vm.msg,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 && (_vm.msg = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.msg = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.msg = $$c
                                    }
                                  }
                                }
                              },
                              "input",
                              _vm.getInputAttrs(),
                              false
                            )
                          )
                        : _vm.getInputAttrs().type === "radio"
                        ? _c(
                            "input",
                            _vm._b(
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.msg,
                                    expression: "msg"
                                  }
                                ],
                                ref: "input",
                                staticClass: "vux-prompt-msgbox",
                                attrs: {
                                  placeholder: _vm.placeholder,
                                  type: "radio"
                                },
                                domProps: { checked: _vm._q(_vm.msg, null) },
                                on: {
                                  touchend: _vm.setInputFocus,
                                  change: function($event) {
                                    _vm.msg = null
                                  }
                                }
                              },
                              "input",
                              _vm.getInputAttrs(),
                              false
                            )
                          )
                        : _c(
                            "input",
                            _vm._b(
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.msg,
                                    expression: "msg"
                                  }
                                ],
                                ref: "input",
                                staticClass: "vux-prompt-msgbox",
                                attrs: {
                                  placeholder: _vm.placeholder,
                                  type: _vm.getInputAttrs().type
                                },
                                domProps: { value: _vm.msg },
                                on: {
                                  touchend: _vm.setInputFocus,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.msg = $event.target.value
                                  }
                                }
                              },
                              "input",
                              _vm.getInputAttrs(),
                              false
                            )
                          )
                    ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "weui-dialog__ft" }, [
            _vm.showCancelButton
              ? _c(
                  "a",
                  {
                    staticClass: "weui-dialog__btn weui-dialog__btn_default",
                    attrs: { href: "javascript:;" },
                    on: { click: _vm._onCancel }
                  },
                  [_vm._v(_vm._s(_vm.cancelText || "取消"))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showConfirmButton
              ? _c(
                  "a",
                  {
                    staticClass: "weui-dialog__btn",
                    class: "weui-dialog__btn_" + _vm.confirmType,
                    attrs: { href: "javascript:;" },
                    on: { click: _vm._onConfirm }
                  },
                  [_vm._v(_vm._s(_vm.confirmText || "确定"))]
                )
              : _vm._e()
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34e5c492", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e5c492","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
// module id = null
// module chunks = 